module.exports = __webpack_public_path__ + "static/media/9DESA2.d4eba0fa.jpg";